import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import Search from '@/components/SearchV3/index.vue';
import { interactiveChannelList } from '@com/utils/channel';
import { nonInteractiveChannelList } from '@/views/demand/utils/creation';
import ExportXlsx from '@/components/ExportXlsxBtn/index.vue';
import { keyworkList, mediaTypeOptions, statusOptions, customerTypeList, timeFilterOptions, paymentList, bizScenario } from '@/common/demand';
import { creationTypeList } from '@/views/demand/utils/creation';
import { headerConfig, cookContent } from '@/common/export-xlsx';
import { sourceList } from '@/common/demand';
import { serviceAttribution, serviceList, projectTypeList } from '@/common/demand';

// 使用字符串的问题：搜索平台时，如果是 ios,android，会将 ios、android 都搜索出来，而不是 ios&android
var platformList = [{
  value: 1,
  label: 'iOS'
}, {
  value: 2,
  label: 'Android'
}, {
  value: 3,
  label: 'Website'
}, {
  value: 4,
  label: '小程序'
}, {
  value: 5,
  label: 'iOS & Android'
}];

// 通过 type + '-' + channel_id 的格式来区分交互渠道与非交互渠道
var SpecialDemandChannelList = _.concat(interactiveChannelList.map(function (item) {
  return {
    label: '交互-' + item.label,
    value: '1-' + item.value
  };
}), nonInteractiveChannelList().map(function (item) {
  return {
    label: '非交互-' + item.label,
    value: '2-' + item.value
  };
}));

export default {
  components: {
    Search: Search,
    ExportXlsx: ExportXlsx
  },

  props: {
    query: {
      type: Object,
      required: true
    },

    handleSearch: {
      type: Function,
      required: true
    },

    handleResetSearch: {
      type: Function,
      required: true
    },

    keyField: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    creationSize: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    formItems: {
      type: Array,
      default: null
    },

    exportTitle: {
      type: String,
      default: ''
    },

    columnConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    showExport: {
      type: Boolean,
      default: false
    },

    renderAll: {
      type: Function,
      default: function _default() {}
    },
    request: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    // 通过父级传入search_field配置项
    return {
      keyFieldConfig: this.keyField.length > 0 ? this.keyField : keyworkList,
      exportContent: []
    };
  },


  computed: {
    // 根据 formItems 过滤表单项
    formItemList: function formItemList() {
      var _this = this;

      return [{
        prop: 'search_field',
        type: 'select',
        params: {
          clearable: false,
          filterable: true,
          style: 'width: 220px;',
          options: this.keyFieldConfig,
          placeholder: '请选择搜索类型'
        }
      }, {
        prop: 'keyword',
        type: 'input',
        params: function params(_ref) {
          var formValue = _ref.formValue;

          console.log(formValue.search_field);
          return {
            disabled: false,
            readonly: false,
            clearable: true,
            style: 'width: 220px;',
            placeholder: formValue.search_field ? '按' + _this.keyFieldConfig.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入关键字'
          };
        }
      }, {
        prop: 'categories',
        type: 'select',
        params: {
          clearable: true,
          multiple: true,
          placeholder: '请选择需求归属',
          style: 'width: 220px;',
          collapseTags: true,
          options: mediaTypeOptions
        }
      }, {
        prop: 'statuses',
        type: 'select',
        params: {
          clearable: true,
          multiple: true,
          placeholder: '请选择需求状态',
          style: 'width: 220px;',
          collapseTags: true,
          options: statusOptions
        }
      }, {
        prop: 'creation_types',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: true,
          multiple: true,
          placeholder: '请选择创意类型',
          collapseTags: true,
          options: creationTypeList
        }
      }, {
        prop: 'creation_size',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: true,
          multiple: true,
          placeholder: '请选择素材尺寸',
          collapseTags: true,
          options: this.creationSize
        }
      }, {
        prop: 'platform_types',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: true,
          multiple: true,
          placeholder: '请选择投放平台',
          collapseTags: true,
          options: platformList
        }
      }, {
        prop: 'channel_ids',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: true,
          multiple: true,
          filterable: true,
          collapseTags: true,
          placeholder: '请选择投放渠道',
          options: SpecialDemandChannelList,
          class: 'search-filter-select'
        }
      }, {
        prop: 'languages',
        type: 'business',
        subtype: 'language-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          collapseTags: true,
          filterable: true,
          class: 'search-filter-select'
        }
      }, {
        prop: 'designer_ids',
        type: 'business',
        subtype: 'designer-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          collapseTags: true,
          filterable: true,
          class: 'search-filter-select'
        }
      }, {
        prop: 'demander_ids',
        type: 'business',
        subtype: 'demander-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          collapseTags: true,
          filterable: true,
          class: 'search-filter-select'
        }
      }, {
        prop: 'account_manager_ids',
        type: 'business',
        subtype: 'account-mgr-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          collapseTags: true,
          filterable: true,
          class: 'search-filter-select'
        }
      }, {
        prop: 'planner_ids',
        type: 'business',
        subtype: 'planner-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          collapseTags: true,
          filterable: true,
          class: 'search-filter-select'
        }
      }, {
        prop: 'tag_ids',
        type: 'business',
        subtype: 'creation-tag-cascader-multi',
        params: {
          collapseTags: true,
          style: 'width: 400px;',
          class: 'search-filter-select',
          params: {
            type: 2
          }
        }
      }, {
        prop: 'developer_ids',
        type: 'business',
        subtype: 'developer-selector',
        params: {
          style: 'width: 220px;',
          multiple: true,
          filterable: true,
          class: 'search-filter-select',
          collapseTags: true
        }
      }, {
        prop: 'adv_ids',
        type: 'business',
        subtype: 'advertiser-selector',
        params: {
          multiple: true,
          filterable: true,
          collapseTags: true,
          style: 'width: 220px;',
          class: 'search-filter-select'
        }
      }, {
        prop: 'key_account',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: true,
          multiple: true,
          placeholder: '请选择是否KA',
          collapseTags: true,
          options: customerTypeList
        }
      }, {
        prop: 'pays',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: true,
          multiple: true,
          collapseTags: true,
          placeholder: '请选择是否付费',
          options: paymentList
        }
      }, {
        prop: 'material_source',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: false,
          placeholder: '请选择素材来源',
          options: sourceList
        }
      }, {
        prop: 'similar_demand_ids',
        type: 'business',
        subtype: 'demand-selector',
        params: {
          placeholder: '请选择参考需求',
          multiple: true,
          filterable: true,
          collapseTags: true,
          style: 'width: 220px;',
          class: 'search-filter-select'
        }
      }, {
        prop: 'biz_scenarios',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: true,
          multiple: true,
          collapseTags: true,
          placeholder: '请选择业务场景',
          options: bizScenario
        }
      }, {
        prop: 'bind_project_ids',
        type: 'input',
        params: function params(_ref2) {
          var formValue = _ref2.formValue;

          return {
            disabled: false,
            readonly: false,
            clearable: true,
            style: 'width: 220px;',
            placeholder: '请输入关联项目 ID'
          };
        }
      }, {
        prop: 'search_time',
        type: 'select',
        params: {
          style: 'width: 220px;',
          clearable: false,
          placeholder: '请选择时间类型',
          options: timeFilterOptions
        }
      }, {
        type: 'date-picker',
        subtype: 'daterange',
        prop: 'time',
        params: {
          disabled: false,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        }
      }];
    },
    innerFormList: function innerFormList() {
      var _this2 = this;

      var tempConfig = [];
      this.formItems.forEach(function (props) {
        var formItem = _this2.formItemList.find(function (item) {
          return item.prop === props;
        });
        if (formItem) {
          tempConfig.push(formItem);
        }
      });
      return tempConfig;
    },
    exportHeader: function exportHeader() {
      var targetConfig = _.cloneDeep(this.columnConfig);
      // 如果包含 staff-cell 相关人员的key，则增加demander_name、account_manager_name、planner_name、designer_name、developer_name等相关人员
      if (targetConfig.indexOf('staff-cell')) {
        targetConfig.splice(targetConfig.indexOf('staff-cell'), 1, 'demander_name', 'account_manager_name');
        targetConfig = targetConfig.concat(['planner_name', 'designer_name', 'developer_name', 'service_attribution_label', 'service_type_label', 'preview_url', 'project_type']);
      }
      return _.pick(headerConfig, targetConfig);
    }
  },

  methods: {
    cookResponse: function cookResponse(res) {
      var list = (_.get(res, 'data.data.list') || []).map(function (item) {
        var attribution = serviceAttribution.find(function (el) {
          return el.value === item.service_attribution;
        }) || {};
        var type = serviceList.find(function (el) {
          return el.value === item.service_type;
        }) || {};
        var projectType = projectTypeList.find(function (el) {
          return el.value === item.project_type;
        }) || {};
        return _extends({}, item, {
          service_attribution_label: attribution.label || '',
          service_type_label: type.label || '',
          project_type: item.project_type === 99 ? item.project_other : projectType.label || ''
        });
      });
      var targetConfig = _.cloneDeep(this.columnConfig);
      // 如果包含 staff-cell 相关人员的key，则增加demander_name、account_manager_name、planner_name、designer_name、developer_name等相关人员
      if (targetConfig.indexOf('staff-cell')) {
        targetConfig.splice(targetConfig.indexOf('staff-cell'), 1, 'demander_name', 'account_manager_name');
        targetConfig = targetConfig.concat(['planner_name', 'designer_name', 'developer_name', 'service_attribution_label', 'service_type_label', 'preview_url', 'project_type']);
      }
      return cookContent(list, targetConfig);
    }
  },

  mounted: function mounted() {}
};